import { cn } from '@/lib/cn';
import { haptic } from '@/lib/telegram';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function Toggle({ checked, onChange, label, disabled, className }: ToggleProps) {
  const toggle = () => {
    if (disabled) return;
    haptic('light');
    onChange(!checked);
  };
  return (
    <div
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }}
      className={cn(
        'flex items-center justify-between gap-3 cursor-pointer select-none outline-none',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      {label && <span className="text-sm text-white/80">{label}</span>}
      <span
        className={cn(
          'relative w-12 h-7 rounded-full transition shrink-0',
          checked ? 'bg-accent' : 'bg-bg-elevated',
        )}
      >
        <span
          className={cn(
            'absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md transition-transform',
            checked && 'translate-x-5',
          )}
        />
      </span>
    </div>
  );
}
